export default "/staticreactui/static/media/static/media/customer0.58cc96ec.webp";